import theme from "@theme/";
import React from "react";
import styled, { keyframes } from "styled-components";

// 🔄 Shimmer Animation
const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

// 🔲 Base shimmer block
const ShimmerBlock = styled.div`
  background: #e9e9e9ff;
  background-image: ${theme.gradient.backgroundTheme};
  background-repeat: no-repeat;
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: 6px;
`;

// 💠 Container styling
const Container = styled.div`
  padding: 20px;
  background: ${theme.gradient.backgroundTheme};
  border-radius: 10px;
  font-family: "Segoe UI", sans-serif;
`;

// 📄 Item Container
const Item = styled.div`
  background: white;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  height: 100px;
`;

// 🟠 View Button Placeholder
const ButtonShimmer = styled(ShimmerBlock)`
  width: 55px;
  height: 30px;
  border-radius: 12px;
`;

// 🧾 Details Section
const Details = styled.div`
  flex: 1;
  margin-left: 12px;
`;

// 📋 Placeholder Lines
const Line = styled(ShimmerBlock)`
  height: ${({ height }) => height || "12px"};
  width: ${({ width }) => width || "80%"};
  margin-bottom: 6px;
  background: ${theme.gradient.backgroundTheme};
`;

const FileListShimmer = () => {
  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Line width="10%" height="20px" />
        <Line width="10%" height="20px" />
      </div>
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} style={{ marginTop: "20px" }}>
          <Line width="100%" height="30px" />
          <Item>
            <ButtonShimmer />
            <Details>
              <Line width="60%" height="14px" />
              <Line width="40%" height="14px" />
            </Details>
            <Line width="10%" height="14px" />
          </Item>
        </div>
      ))}
    </Container>
  );
};

export default FileListShimmer;
